import { useState, useEffect } from "react";
import { useSampleEdit } from "../../../api";

export function Reachback({ sample }) {
  //state variables
  const [isReachback, setIsReachback] = useState(sample.reachback);
  const [isReachbackEmailSent, setIsReachbackEmailSent] = useState(
    sample.isReachbackEmailSent
  );
  const [reachbackReason, setReachbackReason] = useState(
    sample.reachbackReason || {}
  );

  const { mutateAsync } = useSampleEdit(sample._id);

  //when the page first loads, check if reachback is true and email has not been sent
  useEffect(() => {
    if (isReachback && !isReachbackEmailSent) {
      handleReachback();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isReachback]);

  //function for sending reachback email and updating isReachbackEmailSent value in database
  const sendReachbackEmail = async (emailData) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/utility/send-email`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
          body: JSON.stringify({
            to: "reachback@spectraplasmonics.com",
            from: "Reachback Service Requested",
            subject: `Reachback Sample: ${emailData.sampleId}, Customer ID: ${emailData.customerId} `,
            html: `
                    <h1>Sample information:</h1>
                    <p>Customer ID: ${emailData.customerId}</p>
                    <p>Processed Date: ${emailData.processedDate}</p>
                    <p>Sample ID: ${emailData.sampleId}</p>
                    <p>Reachback Reason: ${Object.keys(
                      emailData.reachbackReason
                    ).map((key) => {
                      return ` <strong>${key} - </strong> ${emailData.reachbackReason[key]}`;
                    })}</p>
                    <p>Notes: ${emailData.notes}</p>
                `,
          }),
        }
      );

      const data = await response.json();

      if (response.ok) {
        setIsReachbackEmailSent(true);
        await mutateAsync({
          id: sample._id,
          data: {
            isReachbackEmailSent: true,
            reachback: true,
            reachbackReason,
            reachbackComplete: "inProgress",
          },
        });
      } else {
        console.error("Error sending email:", data.error);
        console.error("Email sending failed!");
        setIsReachbackEmailSent(false);
      }
    } catch (error) {
      console.error("Error sending email:", error);
      console.error("Email sending failed!");
      setIsReachbackEmailSent(false);
    }
  };

  const handleReachback = async () => {
    const emailData = {
      customerId: sample.customerId,
      processedDate: sample.processedDate,
      sampleId: sample.sampleId,
      isErrorT: sample.isErrorT,
      isErrorB: sample.isErrorB,
      reachbackReason: reachbackReason || {},
      notes: sample.description,
    };

    await sendReachbackEmail(emailData);
  };

  const handleClick = () => {
    setIsReachback(true);
    setReachbackReason((prev) => ({
      ...prev,
      customerRequest: "Reachback requested by customer",
    }));
  };

  return (
    <div className='d-flex flex-row justify-content-center align-items-center flex-wrap pt-2'>
      {/* Reachback complete message */}
      {sample.reachbackComplete === "Complete" && (
        <div className='d-flex align-items-center justify-content-center mt-2 w-100 order-2'>
          <i
            className='bi bi-check-circle-fill'
            style={{
              fontSize: "large",
              color: "green",
              marginRight: "10px",
              marginBottom: "2px",
            }}
          ></i>
          <span
            style={{
              color: "black",
            }}
          >
            Reachback completed
          </span>
        </div>
      )}

      {/* Submit for Reachback button */}
      {sample.reachback === false && (
        <div className='d-flex flex-row justify-content-center align-items-center flex-wrap pt-2'>
          <h6 className=' mb-0 text-center me-2 text-wrap'>
            Would you like an expert to review your results?
          </h6>
          <div className='d-flex flex-column width-auto py-1'>
            <button
              type='submit'
              className={`btn btn-primary align-self-center  `}
              style={{ minWidth: "150px" }}
              onClick={handleClick}
              disabled={isReachback}
            >
              {isReachback
                ? "Already Submitted"
                : "Submit for Reachback Service"}
            </button>
            {isReachback ? (
              <p
                className='align-self-center text-center'
                style={{
                  color: "black",
                  fontStyle: "italic",
                }}
              >
                Reachback Submitted - We'll be in touch shortly!
              </p>
            ) : null}
          </div>
        </div>
      )}

      {/* Reachback in progress message */}
      {(sample.reachback === true ||
        sample.reachbackComplete === "inProgress") && (
        <div className='d-flex flex-column align-items-center justify-content-center mt-2 w-100'>
          {sample.reachbackReason &&
          "modelFunctionError" in sample.reachbackReason ? (
            <div className='d-flex align-items-center'>
              <i
                className='bi bi-exclamation-octagon-fill'
                style={{
                  fontSize: "small",
                  color: "#AE0000",
                  marginRight: "10px",
                }}
              ></i>
              <span
                style={{
                  color: "#AE0000",
                  fontWeight: "bold",
                }}
              >
                <small>
                  {
                    "There was a system error while analyzing your scans. The Reachback team will provide further details."
                  }
                </small>
              </span>
            </div>
          ) : sample.isErrorB || sample.isErrorT ? (
            <div className='d-flex align-items-center'>
              <i
                // className='bi bi-exclamation-triangle-fill'
                className='bi-hourglass-split'
                style={{
                  fontSize: "small",
                  color: "#AE0000",
                  marginRight: "10px",
                }}
              ></i>
              <span
                style={{
                  color: "#AE0000",
                  fontWeight: "bold",
                }}
              >
                <small>
                  {`${
                    sample.isErrorB && sample.isErrorT
                      ? "Bulk scan and trace scan"
                      : sample.isErrorB
                      ? "Bulk scan"
                      : sample.isErrorT
                      ? "Trace scan"
                      : "Displayed"
                  } results are currently undergoing expert review and
                should be interpreted cautiously.`}
                </small>
              </span>
            </div>
          ) : sample.reachbackReason &&
            "modelDiscrepancy" in sample.reachbackReason ? (
            <div className='d-flex align-items-center order-last'>
              <i
                className='bi bi-search'
                style={{
                  fontSize: "14px",

                  marginRight: "6px",
                }}
              ></i>
              <span>
                <small>
                  {
                    "The initial analysis suggests that additional substances might be present in the sample. This sample will be reviewed by one of our experts."
                  }
                </small>
              </span>
            </div>
          ) : null}

          <div className='d-flex align-items-center'>
            <i
              className='bi bi-clock-fill'
              style={{
                fontSize: "small",
                marginRight: "10px",
              }}
            ></i>
            <span
              style={{
                fontWeight: "bold",
              }}
            >
              <small>Reachback Submitted - We'll be in touch shortly!</small>
            </span>
          </div>
        </div>
      )}
    </div>
  );
}
